import React from 'react'
import {Tab, Tabs} from 'react-bootstrap'
import {useParams} from 'react-router-dom'
import {
  useGetDetailBatchQuery,
  useGetErrorDetailBatchQuery,
} from '../../../../../redux/api/services/batch'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import CustomTable from '../../../../../helpers/elements/table/CustomTable'
import {
  detailsColumns,
  errorDetailColumns,
} from '../../../../../helpers/elements/table/columns/_columns'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../redux/store'
import {CustomErrorAlert} from '../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

export const ErrorBatchesDetail = () => {
  const {id} = useParams()
  const infoState = useSelector((state: RootState) => state.info)

  const detailBatchStatus = useGetDetailBatchQuery({
    info: infoState,
    requestContent: {batchId: id || ''},
  })

  const detailBatchErrorStatus = useGetErrorDetailBatchQuery({
    info: infoState,
    requestContent: {batchId: id || ''},
  })

  return (
    <>
      <TitleCard title='Pagos fallidos' subtitle='Listado de pagos' goBack='/errors/list' />
      <div className='card'>
        <div className='card-body'>
          {id && (
            <Tabs defaultActiveKey='schedule' className='mb-3'>
              <Tab
                eventKey='schedule'
                className='mt-14'
                title={`Registros válidos (${
                  detailBatchStatus.data?.responseContent.records.length || 0
                })`}
              >
                <CustomErrorAlert
                  error={detailBatchStatus.error}
                  show={detailBatchStatus.isError}
                />

                <CustomTable
                  batchList={detailBatchStatus.data?.responseContent.records || []}
                  isLoading={detailBatchStatus.isLoading}
                  columns={detailsColumns}
                />
              </Tab>
              <Tab
                eventKey='batchErrorsDetail'
                title={`Registos inválidos (${
                  detailBatchErrorStatus.data?.responseContent.errors.length || 0
                })`}
              >
                <CustomErrorAlert
                  error={detailBatchErrorStatus.error}
                  show={detailBatchErrorStatus.isError}
                />

                <CustomTable
                  batchList={detailBatchErrorStatus.data?.responseContent.errors || []}
                  isLoading={detailBatchErrorStatus.isLoading}
                  columns={errorDetailColumns}
                />
              </Tab>
            </Tabs>
          )}
        </div>
      </div>
    </>
  )
}
